<template>
  <div>
    <autoLogout />
    <loader :loader="sending" />
    <div class="wrapper-content">
      <encabezado :elementos="encabezado" v-if="showAction(1)" />
      <v-card v-if="showAction(1)">
        <v-card-text>
          <v-row align="baseline" justify="center" class="pb-4">
            <v-col>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar"
                single-line dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="4"
              xl="2"
              sm="12"
              @click="changeAction(2)"
            >
              <btn-accion :elements="btnAdd"  />
            </v-col>
          </v-row>
        </v-card-text>

        <v-data-table
          :headers="headers"
          :items="list"
          :search="search"
          :items-per-page="10"
          :footer-props="{
            'items-per-page-text': 'Elementos por página',
            'items-per-page-all-text': 'Todo',
          }"
          no-results-text="Sin resultados coincidentes con el búsqueda"
          loading-text="Cargando..."
          no-data-text="Sin resultados disponibles"
          class="mx-5"
          dense
          fixed-header
          height="auto"
        >
          
          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip top v-if="$utilFront.withPermission($prm.MODULE_CONF)">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon @click="checkVitalSignType(item)" x-small>
                  <v-icon color="blue" v-bind="attrs" v-on="on">
                    mdi-pencil
                  </v-icon>
                </v-btn>
              </template>
              <span>Editar información</span>
            </v-tooltip>
            <span v-else> - - - </span>
          </template>
        </v-data-table>
      </v-card>
      <encabezado
        :elementos="encabezado"
        v-if="showAction(2) || showAction(3)"
      />
      <v-card v-if="showAction(2) || showAction(3)">
        <validation-observer ref="form" v-slot="{ invalid }">
          <v-form @submit.prevent="doAction">
            <div class="container">
              <v-row>
                <v-col>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Nombre de Signo Vital"
                    rules="required|max:40"
                  >
                    <v-text-field
                      v-model="dataModal.name"
                      :counter="40"
                      :error-messages="errors"
                      label="Nombre de Signo Vital"
                      required
                      autocomplete="off"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
                <v-col>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Unidad de medida"
                    rules="max:5|required"
                  >
                    <v-text-field
                      v-model="dataModal.suffix"
                      :counter="5"
                      :error-messages="errors"
                      label="Unidad de medida"
                      autocomplete="off"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
                <v-col>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Requerido"
                    rules="required"
                  >
                    <v-autocomplete
                      v-model="dataModal.required"
                      label="Requerido"
                      :items="typeRequeried"
                      :item-text="typeRequeried.text"
                      :item-value="typeRequeried.value"
                      :error-messages="errors"
                    >
                    </v-autocomplete>
                  </validation-provider>
                </v-col>
                <v-col>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Tipo de resultado"
                    rules="required"
                  >
                    <v-autocomplete
                      v-model="dataModal.type"
                      label="Tipo de resultado"
                      :items="typeText"
                      :item-text="typeText.text"
                      :item-value="typeText.value"
                      :error-messages="errors"
                    >
                    </v-autocomplete>
                  </validation-provider>
                </v-col>
              </v-row>
            </div>
            <div class="d-flex justify-center">
              <v-col class="d-flex justify-space-around">
                <div v-on:click="changeAction(1)">
                  <btn-accion :elements="btnCancell" />
                </div>
                <v-btn
                  type="submit"
                  :disabled="sending || invalid"
                  color="success"
                >
                  <v-icon left>{{ iconoAdd }}</v-icon>
                  {{ textoAdd }}
                </v-btn>
              </v-col>
            </div>
          </v-form>
        </validation-observer>
      </v-card>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import Datatable from "../../components/Datatable.vue";
import Encabezado from "@/app/components/base/header/Header.vue";
import Sidebar from "../../components/Sidebar";
import BtnAccion from "../../components/btnAccion.vue";
import AutoLogout from "../../components/AutoLogout.vue";
import { TypeVitalSignRequest } from "@/core/request";
import { required, max } from "vee-validate/dist/rules";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
import { mapActions } from "vuex";
import ExportImportBtn from "../../components/ExportImportBtn.vue";
import Loader from "../../components/Loader.vue";
setInteractionMode("eager");
extend("required", {
  ...required,
  message: "{_field_} no puede quedar vacío",
});
extend("max", {
  ...max,
  message: "{_field_} no debe ser mayor de {length} caracteres",
});

export default {
  name: "Perfiles",
  components: {
    Sidebar,
    Encabezado,
    ValidationObserver,
    ValidationProvider,
    Datatable,
    BtnAccion,
    AutoLogout,
    ExportImportBtn,
    Loader,
  },
  data() {
    return {
      importDialog: false,
      dialog: false,
      search: "",
      dataModal: {},
      action: 1,
      encabezado: {
        icono: "mdi-menu",
        texto: "Signos Vitales",
      },
      list: [],
      listStudyModality: [],
      sending: false,
      dialogs: {
        title: "¿Desea modificar el estatus?",
        text: "La Signo Vital será habilitado / inhabilitado de inmediato y podría afectar a los registros que dependan de él",
      },
      headers: [
        { text: "Id signo Vital", value: "idVitalSignType", align: "center" },
        { text: "Nombre", value: "name", align: "center" },
        { text: "Unidad de medida", value: "suffix", align: "center" },
        { text: "Tipo de resultado", value: "typeText", align: "center" },
        { text: "Requerido", value: "requiredText", align: "center" },
        { text: "Acciones", value: "actions", sortable: false, align: "center" },
      ],
      btnAdd: {
        icon: "mdi-plus",
        text: "Agregar Signo Vital",
        tooltip: "Agregar Signo Vital",
      },
      btnCancell: {
        icon: "mdi-close",
        text: "Cancelar registro",
        tooltip: "Cancelar registro",
        color: "error",
      },
      iconoAdd: "mdi-plus",
      textoAdd: "Registrar Signo Vital",
      service: TypeVitalSignRequest,
      updateModal: false,
      results: {},
      fileXls: null,
      typeRequeried: [
        { text: "Opcional", value: 0 },
        { text: "Obligatorio", value: 1 },
      ],
      typeText: [
        { text: "Númerico", value: 1 },
        { text: "Texto", value: 2 },
      ],
    };
  },
  created() {},
  mounted() {
    this.validBrowserTab();
    this.listAll();
  },
  methods: {
    ...mapActions(["validTab", "unauthorized"]),
    validBrowserTab() {
      this.validTab();
    },
    catchError: (e) => {
      //console.log(e);
      this.$utilFront.notifications("Ha ocurrido un error interno", "ERROR");
    },
    showAction(action) {
      return this.action == action;
    },
    editarStatus(item) {
      this.dialog = true;
      this.dataModal = Object.assign(this.dataModal, item);
    },
    changeAction(action) {
      if (action == 1) {
        this.$refs.form.reset();
        this.dataModal = {};
      } else if (action == 2) {
        this.dataModal = {};
      } else if (action == 3) {
      }
      this.action = action;
      this.checkEncabezado();
    },
    checkEncabezado() {
      switch (this.action) {
        case 1:
          this.encabezado = {
            icono: "mdi-menu",
            texto: "Signos Vitales",
          };
          this.dialogs = {
            title: "¿Desea modificar el estatus?",
            text: "La Signo Vital será habilitado / inhabilitado de inmediato y podría afectar a los registros que dependan de él",
          };
          break;
        case 2:
          this.encabezado = {
            icono: "mdi-menu",
            texto: "Registrar Signo Vital",
          };
          this.dialogs = {
            title: "¿Desea registrar éste Signo Vital?",
            text: "La Signo Vital será registrado de inmediato y estará disponible en el sistema",
          };
          this.iconoAdd = "mdi-plus";
          this.textoAdd = "Registrar Signo Vital";
          this.btnCancell = {
            icon: "mdi-close",
            text: "Cancelar registro",
            tooltip: "Cancelar registro",
            color: "error",
          };
          break;
        case 3:
          this.encabezado = {
            icono: "mdi-menu",
            texto: "Editar Signo Vital",
          };
          this.dialogs = {
            title: "¿Desea modificar éste Signo Vital?",
            text: "La Signo Vital será modificado de inmediato y podría afectar a los registros que dependan de él",
          };
          this.iconoAdd = "mdi-reload";
          this.textoAdd = "Editar Signo Vital";
          this.btnCancell = {
            icon: "mdi-close",
            text: "Cancelar Modificación",
            tooltip: "Cancelar Modificación",
            color: "error",
          };
          break;
        default:
          this.encabezado = {
            icono: "mdi-menu",
            texto: "Signos Vitales",
          };
          break;
      }
    },
    doAction() {
      if (this.$refs.form.validate()) {
        // this.dialog = true;
        if (this.action == 2) {
          this.add();
        } else if (this.action == 3) {
          this.update();
        }
      }
    },
    sendData() {
      this.sending = !this.sending;
    },

    listAll() {
      this.service.listAllTypeVitalSign().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.list = res.data.data.map((vital) => {
            return {
              idVitalSignType: vital.idVitalSignType,
              name: vital.name,
              required: vital.required,
              type: vital.type,
              suffix: vital.suffix,
              typeText: vital.type == 1 ? "Númerico" : "Texto",
              requiredText: vital.required == 1 ? "Obligatorio" : "Opcional",
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    add() {
      if (!this.sending) {
        this.sending = true;
        let postData = {
          name: this.dataModal.name.trim(),
          status: 1,
          required: this.dataModal.required,
          type: this.dataModal.type,
          suffix: this.dataModal.suffix,
        };
        this.service
          .addTypeVitalSign(postData)
          .then((res) => {
            this.listAll();
            if (res.data.code === 200) {
              this.$utilFront.notifications(
                "Signo Vital registrado correctamente",
                "SUCCESS"
              );
              this.changeAction(1);
            } else if (res.data.code === 401) {
              this.unauthorized();
            } else {
              this.$utilFront.notifications(res.data.data, "ERROR");
            }
          })
          .finally(() => {
            this.sending = false;
          });
      }
    },
    update() {
      if (!this.sending) {
        this.sending = true;
        let postData = {
          idVitalSignType: this.dataModal.idVitalSignType,
          name: this.dataModal.name.trim(),
          status: 1,
          required: this.dataModal.required,
          type: this.dataModal.type,
          suffix: this.dataModal.suffix,
        };
        this.service
          .updateTypeVitalSign(postData)
          .then((res) => {
            this.listAll();
            if (res.data.code === 200) {
              this.$utilFront.notifications(
                "Signo Vital modificada correctamente",
                "SUCCESS"
              );
              this.changeAction(1);
            } else if (res.data.code === 401) {
              this.unauthorized();
            } else {
              this.$utilFront.notifications(res.data.data, "ERROR");
            }
          })
          .finally(() => {
            this.sending = false;
          });
      }
    },

    checkVitalSignType(item) {
      this.dataModal = Object.assign(this.dataModal, item);
      this.changeAction(3);
    },
  },
  computed: {},
};
</script>
